import actions from '../action/refund'
import CONSTANT from '../constant/refund'

const refundList = {
  total:0,
  list: []
}
const refundDetail = {}
const refundReason = {}
const serviceTypeList = []
const companyList = []
const refundAmountDetail = {}
const refundRateData = {
  refundOptions: [],
  totalRefundAmount: 0
}
export default {
  actions,
  state: {
    refundList,
    refundDetail,
    refundReason,
    serviceTypeList,
    companyList,
    refundAmountDetail,
    refundRateData,
    selectedServiceType: -1, //默认未选择
    applyPageData: {},
    sendBackActiveItem: {}, //退货方式选择
  },
  mutations: {
    [CONSTANT.REFUND_GET_LIST_SUCCESS] (state, data) {
      state.refundList = data
    },
    [CONSTANT.REFUND_GET_LIST_EMPTY] (state, data) {
        state.refundList = {list: [], total: 0}
    },
    [CONSTANT.REFUND_GET_LIST_ERROR] (state, e) {
      state.refundList = {list: [], total: 0}
    },
    [CONSTANT.REFUND_GET_LIST_MORE_SUCCESS] (state, result) {
      state.refundList = { total: result.total, list: [...state.refundList.list, ...result.list]}
    },
    [CONSTANT.REFUND_GET_DETAIL_SUCCESS] (state, data) {
      state.refundDetail = data
    },
    [CONSTANT.REFUND_GET_DETAIL_ERROR] (state, e) {
      state.refundDetail = {}
    },

    [CONSTANT.REFUND_GET_REASON_SUCCESS] (state, data) {
      state.refundReason = data
    },
    [CONSTANT.REFUND_GET_REASON_EMPTY] (state, data) {
        state.refundReason = {}
    },
    [CONSTANT.REFUND_GET_REASON_ERROR] (state, e) {
      state.refundReason = {}
    },

    [CONSTANT.REFUND_GET_SERVICE_TYPE_SUCCESS] (state, data) {
      state.serviceTypeList = data.serviceTypeList
    },
    [CONSTANT.REFUND_GET_SERVICE_TYPE_EMPTY] (state, data) {
      state.serviceTypeList = []
    },
    [CONSTANT.REFUND_GET_SERVICE_TYPE_ERROR] (state, e) {
      state.serviceTypeList = []
    },

    [CONSTANT.REFUND_GET_EXPRESS_COMPANY_LIST_SUCCESS] (state, data) {
      state.companyList = data.companyList
    },
    [CONSTANT.REFUND_GET_EXPRESS_COMPANY_LIST_EMPTY] (state, data) {
      state.companyList = []
    },
    [CONSTANT.REFUND_GET_EXPRESS_COMPANY_LIST_ERROR] (state, e) {
      state.companyList = []
    },

    [CONSTANT.REFUND_GET_AMOUNT_SUCCESS] (state, data) {
      state.refundAmountDetail = data
    },
    [CONSTANT.REFUND_GET_AMOUNT_ERROR] (state, e) {
      state.refundAmountDetail = {}
    },
    [CONSTANT.REFUND_GET_RATE_OPTIONS_SUCCESS] (state, data) {
      state.refundRateData = data
    },
    [CONSTANT.REFUND_GET_RATE_OPTIONS_EMPTY] (state, data) {
      state.refundRateData = {refundOptions: [],
        totalRefundAmount: 0}
    },
    [CONSTANT.REFUND_GET_RATE_OPTIONS_ERROR] (state, e) {
      state.refundRateData = {refundOptions: [],
        totalRefundAmount: 0}
    },
    SELECT_SERVICE_TYPE(state, serviceType) {
      state.selectedServiceType = serviceType
    },
    RESET_SERVICE_TYPE(state) {
      state.selectedServiceType = -1
    },
    SET_REFUND_APPLY_DATA(state, data) {
      console.log(data)
      state.applyPageData = data
    },
    RESET_REFUND_APPLY_DATA(state) {
      state.applyPageData = {}
    },
    SET_SEND_BACK_ACTIVE_ITEM(state,data) {
      state.sendBackActiveItem = data
    },
    RESET_SEND_BACK_ACTIVE_ITEM(state) {
      state.sendBackActiveItem = {}
    },
  },
  getters: {
  }
}
